module.exports = __webpack_public_path__ + "static/img/3-info-b6.71b2d7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b6.jpg
// module id = g1w2
// module chunks = 0